import { render, staticRenderFns } from "./frame-visual.vue?vue&type=template&id=b6a90b74&scoped=true&"
import script from "./frame-visual.vue?vue&type=script&lang=js&"
export * from "./frame-visual.vue?vue&type=script&lang=js&"
import style0 from "./frame-visual.vue?vue&type=style&index=0&id=b6a90b74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a90b74",
  null
  
)

export default component.exports